module.exports = __webpack_public_path__ + "static/rss-2308cfb40ef0e20cc185e90c0f6c4b26.png";